import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const EllipsisHorizontalCircleOutlinedSize16Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.99935 8C1.99935 4.68629 4.68564 2 7.99935 2C11.3131 2 13.9993 4.68629 13.9993 8C13.9993 11.3137 11.3131 14 7.99935 14C4.68564 14 1.99935 11.3137 1.99935 8ZM7.99935 0.666666C3.94926 0.666666 0.666016 3.94991 0.666016 8C0.666016 12.0501 3.94926 15.3333 7.99935 15.3333C12.0494 15.3333 15.3327 12.0501 15.3327 8C15.3327 3.94991 12.0494 0.666666 7.99935 0.666666ZM4.66569 9C5.21797 9 5.66569 8.55229 5.66569 8C5.66569 7.44772 5.21797 7 4.66569 7C4.11341 7 3.66569 7.44772 3.66569 8C3.66569 8.55229 4.11341 9 4.66569 9ZM7.9987 9C8.55098 9 8.9987 8.55228 8.9987 8C8.9987 7.44772 8.55098 7 7.9987 7C7.44641 7 6.9987 7.44772 6.9987 8C6.9987 8.55228 7.44641 9 7.9987 9ZM12.3327 8C12.3327 8.55228 11.885 9 11.3327 9C10.7804 9 10.3327 8.55228 10.3327 8C10.3327 7.44772 10.7804 7 11.3327 7C11.885 7 12.3327 7.44772 12.3327 8Z"
                fill="var(--magritte-ui-icon-color)"
            />
        </g>
    </svg>
);
const EllipsisHorizontalCircleOutlinedSize16 = hoc<'EllipsisHorizontalCircleOutlinedSize16'>(
    forwardRef(EllipsisHorizontalCircleOutlinedSize16Component),
    'EllipsisHorizontalCircleOutlinedSize16'
);
export default EllipsisHorizontalCircleOutlinedSize16;
